%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: BossPowerupMiniMe
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 0}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 7994f284bb25ca64fa21bb890b0e5e98, type: 3}
  beforeChannelSoundDelay: 0
  beforeChannelSoundVolume: 1
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  afterChannelSoundVolume: 1
  animation: 19
  animationVariation: 0
  castDelay: 0
  animationSpeed: 1
  animationDuration: 0
  skipCooldownOnChannel: 0
  spellName: Mini Me
  description: Every 30 seconds, summon a clone of yourself that deals reduced damage
    and has reduced health.
  icon: {fileID: 2800000, guid: 74e58aba47e666e46994c2700d7a8e29, type: 3}
  usableBy: 
  cooldown: 30
  castTime: 0
  isCastInterruptible: 0
  channelTime: 0
  isOnGlobalCooldown: 0
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 1
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100118
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: ac556daff38a62e4aa55752881d8a3ca, type: 3}
